import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/isomorphic-utils";
import React, { useEffect } from "react";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import LandingButton from "../LandingButton/LandingButton";
import { ModalWrapper } from "../ModalWrapper/ModalWrapper";
import {
  BulletIcon,
  BulletItem,
  BulletList,
  BulletText,
  InfoModalBody,
} from "./InfoModal.style";

interface ListItem {
  icon: string;
  title: TextNodeType;
}

interface InfoModalData {
  heading: {
    title?: TextNodeType;
    subTitle?: TextNodeType;
    img?: string;
  };
  list: ListItem[];
  ctaText: {
    title: TextNodeType;
  };
}

interface InfoModalProps {
  data: InfoModalData;
  isOpen: boolean;
  onClose: () => void;
  onCTAClick?: () => void;
}

export const InfoModal: React.FC<InfoModalProps> = ({
  data,
  isOpen,
  onClose,
  onCTAClick,
}) => {
  if (!data) return null;
  const analytics = getAnalytics();
  const { heading, list, ctaText } = data;
  useEffect(() => {
    analytics?.trackCommonLandingEvents({
      actionType: "annual_multi_trip_bottomsheet_seen",
    });
  }, []);
  const ctaTextInfo =
    typeof ctaText?.title?.text === "object" &&
    !Array.isArray(ctaText?.title?.text)
      ? ctaText?.title?.text?.value
      : "EXPLORE PLANS";

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      {heading?.img && (
        <ImageComponent
          src={heading.img}
          width="500px"
          height="auto"
          alt="Travel Safety"
        />
      )}
      <InfoModalBody>
        <BulletList>
          {list.map((item, index) => (
            <BulletItem key={index}>
              <BulletIcon />
              <BulletText>
                <FormattedText value={item.title} />
              </BulletText>
            </BulletItem>
          ))}
        </BulletList>

        <LandingButton
          customTitle={ctaTextInfo}
          onClick={() => {
            analytics?.trackCommonLandingEvents({
              actionType: "annual_multi_trip_bottomsheet_primary_cta_clicked",
            });
            onCTAClick?.();
          }}
          customWidth="100%"
        />
      </InfoModalBody>
    </ModalWrapper>
  );
};

export default InfoModal;
